import { format, isValid } from 'date-fns';

/** Formats a post's `publishedAt` for display, or null when it cannot be read as a date. */
export function formatPublishedAt(publishedAt: string | null | undefined): string | null {
  if (!publishedAt) {
    return null;
  }

  const date = new Date(publishedAt);

  return isValid(date) ? format(date, 'MMM d, yyyy') : null;
}
